import { render, staticRenderFns } from "./BasicProfile.vue?vue&type=template&id=493905c0&"
import script from "./BasicProfile.vue?vue&type=script&lang=ts&"
export * from "./BasicProfile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports